import { getWindowEnv } from "~/helpers/envConfig";

const { DIGITAL_OPERATION_URL } = getWindowEnv();

export const DVM_URL = `https://${DIGITAL_OPERATION_URL}`;

const baseUrls = {
  development: `${DVM_URL}/api`,
};

const socketUrls = {
  development: `${DVM_URL}/ws`,
};

export const API_URL = baseUrls.development;

export const SOCKET_URL = socketUrls.development;
